// User File Upload Storage Ref
export const kGcsUserFileUploadsBucketRef = import.meta.env.VITE_GCS_USER_UPLOAD_BUCKET
export const kGcsCaseLawSourceBucketRef = import.meta.env.VITE_GCS_CASE_LAW_SOURCE_BUCKET
export const kGcsSecHtmlReferenceBucket = import.meta.env.VITE_GCS_SEC_HTML_REFERENCE_BUCKET
export const kGcsUserFilesPipelineBucketRef = import.meta.env.VITE_GCS_USER_FILES_PIPELINE_BUCKET || 'gs://user-files-pipeline-v1'

// Organization hidden folder (never show in file list, used for org-access files (like org logo))
export const kGcsOrgHiddenFolder = '.org-hidden-xORv2GkKGk'

// Accepted Files List
export const kAcceptedFilesList: { [type: string]: string[] } = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'text/plain': ['.txt'],
  'text/csv': ['.csv'],
  'application/json': ['.json'],
  'text/html': ['.html'],
  'application/xml': ['.xml'],
  'text/markdown': ['.md', '.markdown'],
}

export function getAcceptedFilesList(emailFileProcessingEnabled: boolean): { [type: string]: string[] } {
  return emailFileProcessingEnabled ? { ...kAcceptedFilesList, 'message/rfc822': ['.eml'], 'application/vnd.ms-outlook': ['.msg'] } : kAcceptedFilesList
}

// Accepted Logo Image Extensions List
export const kAcceptedImageFormats: { [type: string]: string[] } = {
  // Image MIME types
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
}

export const kUploadDisclaimer = 'Your documents and data are not used to train Paxton.'
export const MAX_FILE_UPLOAD_SIZE_BYTES = 1024 * 1024 * 1024 // 1GB in bytes
